import { tv } from 'tailwind-variants'

export const infoMessageVariants = tv({
  slots: {
    container: 'items-center gap-x-micro self-end flex flex-row',
    tooltip: 'absolute bg-black text-white px-3 py-2 rounded-md z-[1000] w-[200px] text-center',
    tooltipArrow: 'absolute top-[55%] right-[-6px] w-0 h-0 border-solid',
    messageAt: 'font-medium text-label',
    userStyle: 'font-bold capitalize text-label',
    editLabel: 'font-bold text-label text-secondary-medium'
  },
  variants: {
    source: {
      CLIENT: { container: 'self-start' },
      PRODUCT: { container: 'self-end' }
    }
  }
})
